import React, {useEffect, useRef} from "react";
import TopImage from "../../../assets/images/genius_bestemming.svg";
import FloatingImage from "../../../assets/images/top-section-floating-image.svg";
import AeroplaneBed from "../../../assets/images/icons/aroplane-bed.svg";
import "./style.scss";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import ChatWizard from "../../ChatWizard/ChatWizard";
import {useDispatch, useSelector} from "react-redux";
import {getChatBotData, updateQuestionState} from "../../../redux/slices/chatBotSlice";
import {initialQuestionState} from "../../ChatWizard/chatHelpers";
import {isMobile} from "react-device-detect";
import bgBeachLounge from "../../../assets/images/home-mobile-bg-beach-lounge.webp";
import bgMuseum from "../../../assets/images/home-mobile-bg-museum.webp";
import bgGlacierWaterfall from "../../../assets/images/home-mobile-bg-glacier-waterfall.webp";
import bgNewYorkTimesSquare from "../../../assets/images/home-mobile-bg-new-york-times-square.webp";
import bgThailandTukTuk from "../../../assets/images/home-mobile-bg-thailand-tuk-tuk.webp";
import bgSkiSlope from "../../../assets/images/home-mobile-bg-ski-slope.webp";
import bgJapanSushi from "../../../assets/images/home-mobile-bg-japan-sushi.webp";
import bgSnorkelingReef from "../../../assets/images/home-mobile-bg-snorkeling-reef.webp";
import bgBangkokHotelSuite from "../../../assets/images/home-mobile-bg-bangkok-hotel-suite.webp";
import bgLondonBus from "../../../assets/images/home-mobile-bg-london-bus.webp";
import bgAmalfiYacht from "../../../assets/images/home-mobile-bg-amalfi-yacht.webp";
import bgPoolFloats from "../../../assets/images/home-mobile-bg-pool-floats.webp";
import bgSeasidePromenade from "../../../assets/images/home-mobile-bg-seaside-promenade.webp";
import PropTypes from "prop-types";
import { getSearchFilters } from "../../../redux/slices/searchFilterSlice";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import moment from "moment";
import "moment/locale/nl"; // Import Dutch locale for moment.js
import { resetChatGPTOffers } from "../../../redux/slices/appconfigSlice";

const headerImages = [
    bgBeachLounge,
    bgMuseum,
    bgGlacierWaterfall,
    bgNewYorkTimesSquare,
    bgThailandTukTuk,
    bgSkiSlope,
    bgJapanSushi,
    bgSnorkelingReef,
    bgBangkokHotelSuite,
    bgLondonBus,
    bgAmalfiYacht,
    bgPoolFloats,
    bgSeasidePromenade,
];

const TopSection = ({chatShouldInitiate = false}) => {
    const {T} = useTranslationCustom();
    const dispatch = useDispatch();
    const {GPTChat, questionState, chatTransactionId} = useSelector(getChatBotData);
    const {gptFilters} = useSelector(getSearchFilters);
    const loginConfig = useSelector(getLoginConfig);

    const indexRef = useRef(0);

    // useRef to reference DOM section
    const sectionRef = useRef(null);

    useEffect(() => {
        if (isMobile) {
            const timer = setInterval(() => {
                const nextIndex = (indexRef.current + 1) % headerImages.length;

                // 🔥 Update CSS variable directly without re-render
                const showNextImage = () => {
                    indexRef.current = nextIndex;

                    if (sectionRef.current) {
                        sectionRef.current.style.setProperty(
                            "--chat-bg",
                            `url(${headerImages[nextIndex]})`
                        );
                    }
                };

                // Keep the current photo up until the next one is decoded. Swapping straight
                // away left the header empty for a moment on iOS Safari the first time each
                // photo was shown.
                const nextImage = new Image();
                nextImage.src = headerImages[nextIndex];
                nextImage.decode().then(showNextImage, showNextImage);
            }, 7000);

            return () => clearInterval(timer);
        }
    }, []);

    useEffect(() => {
        if (questionState.length === 0 && GPTChat.length === 0) {
            // Normalize gptFilters.leaveTime with current locale before initializing
            const normalizedFilters = { ...gptFilters };
            if (gptFilters?.leaveTime && loginConfig?.locale?.code) {
                const momentLocale = loginConfig.locale.code.split('_')[0].toLowerCase();
                
                // Try parsing with current locale first, then fallback to English
                let parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], momentLocale);
                
                if (!parsedDate.isValid()) {
                    // Try parsing with English locale if current locale fails
                    parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], 'en');
                }
                
                if (parsedDate.isValid()) {
                    normalizedFilters.leaveTime = parsedDate.locale(momentLocale).format("DD MMMM YYYY");
                }
            }
            dispatch(resetChatGPTOffers());
            dispatch(updateQuestionState(initialQuestionState(T, normalizedFilters)));
        }
    }, [chatTransactionId, questionState, chatShouldInitiate]);

    return (
        <section
            ref={sectionRef}
            id="top-section"
            className="top-section-wrapper"
            style={{
                "--chat-bg": `url(${headerImages[0]})` // initial background
            }}
        >
            <div className="container">
                <div className="content-wrapper d-flex">
                    <div className="image-holder">
                        <img src={TopImage} alt={'top-img'}/>
                    </div>

                    <img src={FloatingImage} className="floating-image" alt={'floating-image'}/>

                    <div className="content-hodler">
                        <h6 className="subtitle heading fs-17 white-text font-noto">
                            <img src={AeroplaneBed} alt={'aeroplane'}/>
                            {T("Home:Home_Hotel_Incl_Flight").toUpperCase()}
                        </h6>

                        <h1 className="heaidng white-text bold font-noto">
                            {/* {T("Home:Home_Explore_Globe")}  Not in use {T("Home:Home_Explore_Globe")} */}
                            {T("Home:Home_Explore_Globe_Mobile")}
                        </h1>

                        <p className="white-text heading-text fs-22 font-noto ">
                            {T("Home:Home_Find_And_Book_Text")}
                        </p>

                        <p className="white-text heading-text fs-22 font-noto top-txt-mobile-only mobile-only">
                            {T("Home:Home_Explore_Globe_Mobile")}
                        </p>
                    </div>
                </div>
            </div>

            <ChatWizard hidden={!chatShouldInitiate && questionState.length > 0}/>
        </section>
    );
};

TopSection.propTypes = {
    chatShouldInitiate: PropTypes.bool
}

export default React.memo(TopSection);
